module.exports = __webpack_public_path__ + "static/img/15.2b26ee5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/4/zh/15.png
// module id = WGt7
// module chunks = 0